import cx from 'classnames';
import {useRef} from 'react';
import {EditButton} from '~/common/components/EditButton/EditButton';
import {useMapLocation} from '~/common/hooks/useMapLocation';
import {Label} from '~/ViewInvitation/common/Label';
import {useConnectEditor} from '~/ViewInvitation/hooks/useConnectEditor';
import {Typography} from '~library/atoms/Typography';
import './LocationBlock.sass';

export const LocationBlock = ({className = '', editable = false}) => {
  const {placeId, meetingUrl, showMap, formatAddress, location} = useMapLocation();

  const containerRef = useRef(null);
  const editBtnRef = useRef(null);

  useConnectEditor(containerRef, editBtnRef, editable && !!location);

  return (
    <div
      className={cx(
        'view-invitation__details-module__section',
        'view-invitation__location-block',
        {editable},
        className
      )}
      ref={containerRef}
    >
      <EditButton data-qa-id="edit-location" ref={editBtnRef} hide={!editable} />
      <div>
        <Label value="Location" />
        <Typography variant="paragraph1" className="view-invitation__details-module__section-body">
          {meetingUrl ? (
            <a href={meetingUrl} target="_blank" rel="noreferrer">
              {meetingUrl}
            </a>
          ) : (
            formatAddress()
          )}
        </Typography>
      </div>
      {placeId && showMap && (
        <iframe
          title="Google Map"
          width="100%"
          height="240"
          loading="lazy"
          allowFullScreen
          className="view-invitation__map"
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps/embed/v1/place?key=${window.mapEmbedApiKey}
    &q=place_id:${placeId}`}
        />
      )}
    </div>
  );
};
